export default __webpack_public_path__ + "static/media/edit-pencil-hover-icon.b2c4b4e0.svg";